type IThemeColor = 'a' | 'b' | 'c' | 'd' | 'e'

export default {
  /**
   * a: Christmas
   * b: 2022 New Year
   */
  skinImage: process.env.VUE_APP_SKIN_IMAGE as IThemeColor,
  decimal: 8,
  themeColor: {
    a: {
      color: '#0B552D'
    },
    b: {
      color: '#edf1f7'
    },
    c: {
      color: '#FF0400'
    },
    d: {
      color: '#402FAA'
    },
    e: {
      color: '#4E5EFF'
    }
  } as {
    [key in IThemeColor]: {
      color: string
      bg: string
    }
  }
}
